var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 17,
    viewBox: "0 0 29 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.89 8.7c0 2.807 1.689 5.223 4.111 6.3H6c-3.314 0-6-2.686-6-6s2.686-6 6-6h10.923c-1.83 1.242-3.032 3.332-3.032 5.7z",
    transform: "translate(-1094 -432) translate(104 193) translate(939 78) translate(51 161) matrix(-1 0 0 1 29 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0C25.194 0 29 3.806 29 8.5S25.194 17 20.5 17 12 13.194 12 8.5 15.806 0 20.5 0zm0 2.345c-3.4 0-6.155 2.756-6.155 6.155 0 3.4 2.756 6.155 6.155 6.155 3.4 0 6.155-2.756 6.155-6.155 0-3.4-2.756-6.155-6.155-6.155z",
    transform: "translate(-1094 -432) translate(104 193) translate(939 78) translate(51 161) matrix(-1 0 0 1 29 0)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDisabled);
export default __webpack_public_path__ + "static/media/icons-disabled.39a47efa327524c03873a27124369f73.svg";
export { ForwardRef as ReactComponent };